import { render } from "./AddCustomer.vue?vue&type=template&id=ced9d5f8&scoped=true"
import script from "./AddCustomer.vue?vue&type=script&lang=js"
export * from "./AddCustomer.vue?vue&type=script&lang=js"

import "./AddCustomer.vue?vue&type=style&index=0&id=ced9d5f8&lang=css"
import "./AddCustomer.vue?vue&type=style&index=1&id=ced9d5f8&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ced9d5f8"]])

export default __exports__